import {
  Button,
  ButtonSize,
  ButtonVariant,
  DataStatus,
  useAnimatedPopper,
} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {ReactNode} from 'react';

interface IntegrationPopperProps {
  buttonTitle: string;
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  isButtonDisabled?: boolean;
  isLoading?: boolean;
  isError?: boolean;
  isEmpty?: boolean;
  children: ReactNode;
  onOpen?: () => void;
  onToggle?: () => void;
  onHover?: () => void;
  isOutsideClickIgnored?: boolean;
  'data-testid'?: string;
}

export function IntegrationPopper(props: IntegrationPopperProps) {
  const {popperProps, Popper, togglePopper, referenceRef} = useAnimatedPopper({
    placement: 'bottom-end',
    gutter: 4,
    isOutsideClickIgnored: props.isOutsideClickIgnored,
    autoUpdateOptions: 'default',
  });

  const handleButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    props.onOpen?.();
    props.onToggle?.();
    togglePopper();
  };

  return (
    <>
      <Box ref={referenceRef}>
        <span onMouseEnter={props.onHover}>
          <Button
            title={props.buttonTitle}
            variant={props.buttonVariant ?? 'secondary'}
            size={props.buttonSize}
            data-testid={props['data-testid']}
            onClick={handleButtonClick}
            isDisabled={props.isButtonDisabled}
          />
        </span>
      </Box>
      <Popper {...popperProps}>
        <div onClick={(event) => event.stopPropagation()}>
          <Box
            borderRadius="medium"
            boxShadow="elevation_2"
            border="1px solid"
            borderColor="palettes.neutral.40.100"
            backgroundColor="general.white"
            padding={3}
          >
            <DataStatus isLoading={props.isLoading} isError={props.isError} isEmpty={props.isEmpty}>
              <Box padding={2}>
                <VStack spacing={4}>{props.children}</VStack>
              </Box>
            </DataStatus>
          </Box>
        </div>
      </Popper>
    </>
  );
}
